<template>
  <span class="tag" @click="goPhotoPage">
    {{ label.chinese }}
  </span>
</template>
<script>

  export default {
    props: {
      label: Object,
      origin: String
    },
    methods: {
      goPhotoPage () {
        if (this.label.parentLabel) {
          window.location.href = `/${ this.origin }/${ this.label.parentLabel.pinyin }/${ this.label.pinyin }/`
        } else {
          window.location.href = `/${ this.origin }/${ this.label.pinyin }/`
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .tag {
    margin: 0 px2rem(5px) px2rem(5px) 0;
    padding: px2rem(5px);
    border: 1px solid #D9D9D9;
    font-size: px2rem(12px);
    line-height: px2rem(12px);
    color: #4C91E2;
    font-weight: 500;
  }
  .tag:hover {
    color: #FF3399;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tag.vue